import DefaultProfileImage from '~/images/defaultProfileImage.png';

/**
 * Determines if an office has child offices (is a parent office).
 * Note: The API includes the parent office itself in the childOffices array,
 * so we check for length > 1 to determine if there are actual child offices.
 *
 * @param childOffices - Array of child offices from the user state
 */
export const hasChildOffices = (childOffices?: unknown[] | null): boolean => {
  return Array.isArray(childOffices) && childOffices.length > 1;
};

/**
 * How many locations an account has. `childOffices` lists the parent among its
 * locations and is kept empty for a single-location office, which counts as one.
 */
export const getLocationCount = (childOffices?: unknown[] | null): number =>
  childOffices?.length || 1;

/**
 * The photo to show for an office. An office with no photo keeps the portal's
 * branded default rather than the design system's tooth avatar (GOTU-4428 Q2).
 */
export const getOfficeAvatarUrl = (profileImage?: string | null): string =>
  profileImage || DefaultProfileImage;
